import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  const handleClick = () => {
    trackAddToCart();
  };
  return <section id="cta-protocolo" className="py-24 md:py-32 px-4 bg-[#221e1b] border-t border-[#d4a574]/10" data-id="element-9">
      <div className="max-w-3xl mx-auto text-center" data-id="element-10">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-4xl md:text-5xl font-serif text-[#f5efe6] mb-6" data-id="element-11">
          Acompañada, aunque estés sola.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="text-xl text-[#a8a29e] mb-12 font-light" data-id="element-12">
          Empieza esta noche. 10 noches es todo lo que necesitas.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative inline-block group" data-id="element-13">
          <div className="absolute inset-0 bg-[#d4a574] blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-500" data-id="element-14" />
          <a href="https://cuerpoencalma.it.com/cart/47441543692475:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="relative flex items-center gap-3 px-10 py-5 bg-[#d4a574] hover:bg-[#c4956a] text-[#1a1714] rounded-full font-medium text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-15">
            Quiero mi Protocolo 3R
            <ArrowRight size={20} data-id="element-16" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-8 text-sm text-[#a8a29e]/60 uppercase tracking-widest" data-id="element-17">
          Un solo pago · Sin suscripciones · Acceso inmediato
        </motion.p>
      </div>
    </section>;
}